import { render, staticRenderFns } from "./RptCancelados.vue?vue&type=template&id=a42cbfe2&"
import script from "./RptCancelados.vue?vue&type=script&lang=js&"
export * from "./RptCancelados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports